import { render, staticRenderFns } from "./Tutor.vue?vue&type=template&id=c424c2a6"
import script from "./Tutor.vue?vue&type=script&lang=js"
export * from "./Tutor.vue?vue&type=script&lang=js"
import style0 from "./Tutor.vue?vue&type=style&index=0&id=c424c2a6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports